import React from "react"
import { Spinner } from "../../components/shared/Spinner"
import { RequestError } from "../../components/shared/RequestError"
import { SmartDateFormat } from "../../util/dates"
import { Currency } from "../../util/numbers"
import { usePayoutTicketPurchases } from "../../hooks/usePayoutTicketPurchases"

interface PayoutTicketPurchase {
  id: number
  ticket_id: string
  amount: number
  band_share: number
  created_at: string
  guest_name?: string | null
  guest_email?: string | null
  purchaser: {
    id: number
    name: string
    email: string
    first_name: string
    last_name: string
  } | null
}

interface PayoutTicketListProps {
  payoutId: number
  showTitle?: string
}

export const PayoutTicketList: React.FC<PayoutTicketListProps> = ({
  payoutId,
  showTitle,
}) => {
  const { error, data, status } = usePayoutTicketPurchases(payoutId, 1, 100)

  return (
    <li>
      <ul>
        <li className="font-bold">Ticket Purchases Breakdown</li>
        {showTitle && (
          <li className="lg:hidden text-xs text-gray-600">{showTitle}</li>
        )}
        {status === "loading" ? (
          <Spinner />
        ) : status === "error" ? (
          <RequestError error={error} />
        ) : data?.items ? (
          data.items.map((ticket: PayoutTicketPurchase) => (
            <li
              key={ticket.id}
              className="grid grid-cols-24 py-2 bg-gray-100 text-sm my-1"
            >
              <div className="col-span-1"></div>
              <div className="col-span-8 lg:col-span-5">
                {SmartDateFormat({ dateStr: ticket.created_at })}
              </div>
              <div className="hidden lg:block lg:col-span-4 font-mono text-xs">
                {ticket.ticket_id}
              </div>
              <div className="col-span-12 lg:col-span-11 px-2">
                <div>
                  {ticket.purchaser
                    ? `${ticket.purchaser.first_name} ${ticket.purchaser.last_name}`
                    : ticket.guest_name || "Guest"}
                </div>
                <div className="text-gray-500 text-xs">
                  {ticket.purchaser
                    ? ticket.purchaser.email
                    : ticket.guest_email}
                </div>
              </div>
              <div className="col-span-3 lg:col-span-2 text-right">
                {Currency(ticket.amount)}
              </div>
            </li>
          ))
        ) : null}
      </ul>
    </li>
  )
}
